"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Brazilian Portuguese
var strings = {
  prefixAgo: 'há',
  prefixFromNow: 'em',
  suffixAgo: null,
  suffixFromNow: null,
  seconds: 'alguns segundos',
  minute: 'um minuto',
  minutes: '%d minutos',
  hour: 'uma hora',
  hours: '%d horas',
  day: 'um dia',
  days: '%d dias',
  month: 'um mês',
  months: '%d meses',
  year: 'um ano',
  years: '%d anos'
};
var _default = strings;
exports["default"] = _default;